import React from "react";
import {
	ComposableMap,
	Geographies,
	Geography,
	ZoomableGroup,
} from "react-simple-maps";
import { Tooltip } from "react-tooltip"; // Ensure react-tooltip is installed
import { WORLD_ATLAS_URL } from "../../config/environment";

const geoUrl = WORLD_ATLAS_URL;

const mapCountryDataToIso = (analyticsData) => {
	if (!Array.isArray(analyticsData)) return [];

	return analyticsData
		.map((item) => {
			return {
				name: item.location,
				id: item.numId,
				count: item.count,
			};
		})
		.filter(Boolean);
};

const WorldMap = ({ data }) => {
	const mappedData = mapCountryDataToIso(data);

	const getColor = (count) => {
		if (count > 1000) return "#800026"; // Dark red
		if (count > 500) return "#BD0026"; // Red
		if (count > 250) return "#E31A1C"; // Bright red
		if (count > 100) return "#FC4E2A"; // Orange-red
		if (count > 50) return "#FD8D3C"; // Dark orange
		if (count > 10) return "#FEB24C"; // Light orange
		if (count > 1) return "#FED976"; // Light yellow
		if (count === 1) return "#FFFFCC"; // Pale yellow
		return "#cccccc"; // Gray for no data
	};
	const countryMap = Object.fromEntries(
		mappedData.map((d) => [d.id, { count: d.count, name: d.name }])
	);

	return (
		<div style={{ width: "80%", height: "auto", marginTop: "20px" }}>
			<h3 className="text-md">География пользователей</h3>
			<ComposableMap projectionConfig={{ scale: 200 }}>
				<ZoomableGroup zoom={1} minZoom={1} maxZoom={3} center={[0, 0]}>
					<Geographies geography={geoUrl}>
						{({ geographies }) =>
							geographies.map((geo) => {
								const countryData = countryMap[geo.id] || {
									count: 0,
									name: geo.properties.name,
								};
								return (
									<Geography
										key={geo.rsmKey}
										geography={geo}
										fill={getColor(countryData.count)}
										strokeWidth={0.5}
										data-tooltip-id="map-tooltip"
										data-tooltip-content={`${countryData.name}: ${countryData.count}`}
										style={{
											hover: {
												fill: "#1f77b4", // Blue on hover
												stroke: "#ffffff", // White outline on hover
												strokeWidth: 1.5, // Thicker outline on hover
												outline: "none",
											},
											default: {
												outline: "none",
											},
										}}
									/>
								);
							})
						}
					</Geographies>
				</ZoomableGroup>
			</ComposableMap>
			<Tooltip id="map-tooltip" />
		</div>
	);
};

export default WorldMap;
